module.exports = __webpack_public_path__ + "static/img/Reproductive-health_icon-32.2d98a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-test/Reproductive-health_icon-32.png
// module id = WVrO
// module chunks = 0